import { BaseModel } from './base.model';

export class MeasureTableMeasureModel {
    sequence: number;
    description: string;
    tolerance: number;
    values: any[];

    constructor(columnCount: number = 0) {
        this.sequence = 0;
        this.description = '';
        this.tolerance = 0;
        this.values = Array(columnCount).fill(null);
    }
}

export class MeasureTableModel extends BaseModel {
    origin: string;
    name: string;
    model_code: string;
    product_description: string;
    grid_labels: string[];
    measures: MeasureTableMeasureModel[];

    static validate(m: MeasureTableModel): boolean {
        if (!m.name || !m.model_code) return false;
        if (!m.grid_labels || m.grid_labels.length === 0) return false;
        if (!m.measures || m.measures.length === 0) return false;

        const trimmed = m.grid_labels.map(l => l ? l.trim() : '');
        if (trimmed.some(l => !l)) return false;
        if (new Set(trimmed).size !== trimmed.length) return false;

        for (const measure of m.measures) {
            if (!measure.description || !measure.description.trim()) return false;
            if (measure.tolerance === null || measure.tolerance === undefined || Number(measure.tolerance) < 0) return false;
            if (!measure.values || measure.values.length !== m.grid_labels.length) return false;
            for (const val of measure.values) {
                if (val === null || val === undefined || val === '') return false;
                if (isNaN(Number(val))) return false;
            }
        }
        return true;
    }

    constructor(m?: any) {
        super();
        this.origin = 'manual';
        this.name = m ? m.name || null : null;
        this.model_code = m ? m.model_code || null : null;
        this.product_description = m ? m.product_description || null : null;
        this.grid_labels = m ? (m.grid_labels || ['PP', 'P', 'M', 'G', 'GG']) : ['PP', 'P', 'M', 'G', 'GG'];
        this.measures = m ? (m.measures || []) : [];
    }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/model/measure-table.model.ts